import { Company } from './company';

export enum DefaultOrderUnit {
    Each = 'each',
    Case = 'case'
}

export class LegacyVendor extends Company {
    externalVendorId: string;
    freeShippingAmount: number;
    minimumOrderAmount: number;
    newVendorId: number;
    legacyId: number;
    partitionEnabled: boolean;
    defaultOrderUnit?: DefaultOrderUnit;

    constructor(options?: Partial<LegacyVendor>) {
        super(options);
        Object.assign(this, options);
    }
}
